import { Condition } from 'models';
import {
  Color,
  Bitmask, createBitmask,
  toCamelCaseObject, toSnakeCaseObject
} from 'utils';

export interface Status {
  companyId?: number;
  factoryId?: number;
  id: string;
  name: string;
  priority?: number;
  orGroupId?: number;
  countMin?: number;
  countMax?: number;
  colorRgb?: Color;
  isCountTarget?: boolean;
  isEnabled?: boolean;
  objectId?: string;
  objectName?: string;
  objectColorRgb?: Color;
  conditionId: string;
  conditionName?: string;
  conditionColorRgb?: Color;
}

export function parseStatus(a: any): Status {
  let obj = toCamelCaseObject(a);
  if (obj.colorRgb) {
    obj.colorRgb = new Color(obj.colorRgb as number)
  }
  if (obj.objectColorRgb) {
    obj.objectColorRgb = new Color(obj.objectColorRgb as number)
  }
  if (obj.conditionColorRgb) {
    obj.conditionColorRgb = new Color(obj.conditionColorRgb as number)
  }
  return obj as Status;
}
export function parseStatuses(arr: any[]): Status[] {
  return arr?.map(a => parseStatus(a));
}

export function encodeStatus(a: Status): any {
  const obj: any = {...a};
  obj.colorRgb = a.colorRgb?.toNumber();
  obj.objectColorRgb = a.objectColorRgb?.toNumber();
  obj.conditionColorRgb = a.conditionColorRgb?.toNumber();
  return toSnakeCaseObject(obj);
}
export function encodeStatuses(arr: Status[]): any[] {
  return arr?.map(a => encodeStatus(a));
}

export interface StatusChartProp {
  id: string;
  name: string;
  backgroundColor?: string;
  borderColor?: string;
}

export type StatusConditionGroup = {[objectId: string]: Status[]};

export interface StatusItem {
  companyId?: number;
  factoryId?: number;
  id: string;
  name: string;
  priority?: number;
  orGroupId?: number;
  colorRgb?: Color;
  isCountTarget?: boolean;
  isEnabled?: boolean;
  conditions: StatusConditionGroup;
}

export function getConditionFromStatus(status: Status): Condition {
  return {
    objectId: status.objectId,
    objectName: status.objectName,
    objectColorRgb: status.objectColorRgb,
    id: status.conditionId,
    name: status.conditionName,
    colorRgb: status.conditionColorRgb
  } as Condition;
}

export function makeStatusItems(statuses: Status[]): StatusItem[] {
  const groupedItems: { [objectId: string]: StatusItem } = {};
  statuses.forEach((status) => {
    const { id, objectId } = status;
    if (id && objectId) {
      if (!groupedItems[id]) {
        groupedItems[id] = {
          companyId: status.companyId,
          factoryId: status.factoryId,
          id: status.id,
          name: status.name,
          priority: status.priority,
          orGroupId: status.orGroupId,
          colorRgb: status.colorRgb,
          isCountTarget: status.isCountTarget,
          isEnabled: status.isEnabled,
          conditions: {},
        };
      }
      if (!groupedItems[id].conditions[objectId]) {
        groupedItems[id].conditions[objectId] = []
      }
      groupedItems[id].conditions[objectId].push(status);
    }
  });
  return Object.values(groupedItems);
}
